<ion-text [innerHTML]="translationKey+'.win_dialog.text' |  translate:{ duration: duration, moveCounter: moveCounter }"></ion-text>
<div *ngIf="data.hasSolutionWord">
  <ion-text><p>{{ translationKey+".win_dialog.solution_message" |  translate}}</p></ion-text>
  <lib-app-puzzle-solution-word-animation [solutionOriginal]="data.solutionOriginal" [solutionWord]="data.solutionWord"
                                          class="word-search-solution-word">
  </lib-app-puzzle-solution-word-animation>
</div>
